import PropTypes from 'prop-types';

const FilingWebsiteSvg = ({ uniqueKey, width, height, palette = [] }) => {
  return (
    <svg
      width={`${width || 50}`}
      height={`${height || 50}`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50 5.95703C50 3.52529 48.0373 1.5625 45.6055 1.5625H4.39453C1.96279 1.5625 0 3.52529 0 5.95703V16.2109L5.97539 17.617C4.13848 18.9491 2.92969 21.0978 2.92969 23.5352V38.1836C2.92969 42.222 6.21416 45.5078 10.2539 45.5078H21.9727C24.684 45.5078 27.2234 44.0107 28.4896 41.8166C29.1936 42.2963 30.0426 42.5781 30.957 42.5781H42.6758C45.099 42.5781 47.0703 40.6068 47.0703 38.1836C47.0703 37.054 46.6301 36.0332 45.9273 35.2539C46.6301 34.4746 47.0703 33.4538 47.0703 32.3242C47.0703 31.1946 46.6301 30.1738 45.9273 29.3945C46.6301 28.6152 47.0703 27.5944 47.0703 26.4648C47.0703 24.0416 45.099 22.0703 42.6758 22.0703H30.957C30.3979 22.0703 29.8675 22.1854 29.3751 22.3767C29.3066 21.9502 29.1993 21.5368 29.0609 21.1378L50 16.2109V5.95703Z"
        fill={`url(#paint0_linear_83_10723${width + height}${uniqueKey})`}
      />
      <path
        d="M0 16.2109V44.043C0 46.4747 1.96279 48.4375 4.39453 48.4375H45.6055C48.0373 48.4375 50 46.4747 50 44.043V16.2109H0ZM26.3672 38.1836C26.3672 40.6153 24.4044 42.5781 21.9727 42.5781H10.2539C7.82217 42.5781 5.85938 40.6153 5.85938 38.1836V23.5352C5.85938 21.1034 7.82217 19.1406 10.2539 19.1406H21.9727C24.4044 19.1406 26.3672 21.1034 26.3672 23.5352V38.1836ZM42.6758 39.6484H30.957C30.1366 39.6484 29.4922 39.004 29.4922 38.1836C29.4922 37.3632 30.1366 36.7188 30.957 36.7188H42.6758C43.4962 36.7188 44.1406 37.3632 44.1406 38.1836C44.1406 39.004 43.4962 39.6484 42.6758 39.6484ZM42.6758 33.7891H30.957C30.1366 33.7891 29.4922 33.1446 29.4922 32.3242C29.4922 31.5038 30.1366 30.8594 30.957 30.8594H42.6758C43.4962 30.8594 44.1406 31.5038 44.1406 32.3242C44.1406 33.1446 43.4962 33.7891 42.6758 33.7891ZM42.6758 27.9297H30.957C30.1366 27.9297 29.4922 27.2853 29.4922 26.4648C29.4922 25.6444 30.1366 25 30.957 25H42.6758C43.4962 25 44.1406 25.6444 44.1406 26.4648C44.1406 27.2853 43.4962 27.9297 42.6758 27.9297ZM30.957 10.3516H42.6758C43.4855 10.3516 44.1406 9.69639 44.1406 8.88672C44.1406 8.07705 43.4855 7.42188 42.6758 7.42188H30.957C30.1474 7.42188 29.4922 8.07705 29.4922 8.88672C29.4922 9.69639 30.1474 10.3516 30.957 10.3516ZM7.32422 10.3516C8.1332 10.3516 8.78906 9.6957 8.78906 8.88672C8.78906 8.07773 8.1332 7.42188 7.32422 7.42188C6.51523 7.42188 5.85938 8.07773 5.85938 8.88672C5.85938 9.6957 6.51523 10.3516 7.32422 10.3516ZM13.1836 10.3516C13.9926 10.3516 14.6484 9.6957 14.6484 8.88672C14.6484 8.07773 13.9926 7.42188 13.1836 7.42188C12.3746 7.42188 11.7188 8.07773 11.7188 8.88672C11.7188 9.6957 12.3746 10.3516 13.1836 10.3516ZM19.043 10.3516C19.852 10.3516 20.5078 9.6957 20.5078 8.88672C20.5078 8.07773 19.852 7.42188 19.043 7.42188C18.234 7.42188 17.5781 8.07773 17.5781 8.88672C17.5781 9.6957 18.234 10.3516 19.043 10.3516ZM16.1133 30.8594C15.3036 30.8594 14.6484 31.5146 14.6484 32.3242V35.2539C14.6484 36.0636 15.3036 36.7188 16.1133 36.7188C16.9229 36.7188 17.5781 36.0636 17.5781 35.2539V32.3242C17.5781 31.5146 16.9229 30.8594 16.1133 30.8594ZM16.1133 25C15.3043 25 14.6484 25.6559 14.6484 26.4648C14.6484 27.2738 15.3043 27.9297 16.1133 27.9297C16.9223 27.9297 17.5781 27.2738 17.5781 26.4648C17.5781 25.6559 16.9223 25 16.1133 25Z"
        fill={`url(#paint1_linear_83_10723${width + height}${uniqueKey})`}
      />
      <defs>
        <linearGradient
          id={`paint0_linear_83_10723${width + height}${uniqueKey}`}
          x1="25"
          y1="45.5078"
          x2="25"
          y2="1.5625"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[2]} />
          <stop offset="1" stopColor={palette[3]} />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_83_10723${width + height}${uniqueKey}`}
          x1="25"
          y1="48.4375"
          x2="25"
          y2="7.42188"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[0]} />
          <stop offset="1" stopColor={palette[1]} />
        </linearGradient>
      </defs>
    </svg>
  );
};

FilingWebsiteSvg.propTypes = {
  uniqueKey: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  palette: PropTypes.arrayOf(PropTypes.string),
};

export default FilingWebsiteSvg;
